import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import CommonModal from '../Modals/common'
import NumberFormat from 'react-number-format'
import './styles.scss'
import { isMobile } from 'react-device-detect'
import { celsiusToFahrenheit, fahrenheitToCelsius, coversion, Settings } from '../../constants/common'

class Home extends Component {
  constructor() {
    super()
    this.state = {
      room: null,
      rooms: [],
      active: false,
      showSaveBtn: false,
      showInfo: false,
      temperatureType: false,
      error: '',
      roomId: 0
    }
    this.showInfo = this.showInfo.bind(this)
    this.temperature = Settings.MinMax()
    this.celsiusToFahrenheit = celsiusToFahrenheit
    this.fahrenheitToCelsius = fahrenheitToCelsius
    this.coversion = coversion
    this.closeModal = this.closeModal.bind(this)
    this.changeRoom = this.changeRoom.bind(this)
    this.setPointUp = this.setPointUp.bind(this)
    this.setPointReleaseUp = this.setPointReleaseUp.bind(this)
    this.setPointDown = this.setPointDown.bind(this)
    this.setPointReleaseDown = this.setPointReleaseDown.bind(this)
    this.changePoint = this.changePoint.bind(this)
  }

  componentWillMount() {
    const { fetchRooms } = this.props
    fetchRooms()
    const roomId = localStorage.getItem('room') ? localStorage.getItem('room') : 0
    this.setState({ roomId: parseInt(roomId, 10) })
  }

  componentWillReceiveProps(np) {
    const { rooms, setPoints, clearCozyProps, history } = np
    if (rooms && rooms !== this.props.rooms) {
      this.setState({ rooms }, () => {
      // Set data for single a room filtering using room id and convert fahrenheit to celsius or vice-versa
        const room = rooms.filter(room => room.id === this.state.roomId)[0] ? rooms.filter(room => room.id === this.state.roomId)[0] : rooms[0]
        room.currentTemp = this.coversion() === 'F' ? room.currentTemp && this.celsiusToFahrenheit(room.currentTemp) : room.currentTemp
        room.home = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.home) : Math.round(room.home)
        room.setpoint = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.setpoint) : Math.round(room.setpoint)
        room.sleep = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.sleep) : Math.round(room.sleep)
        this.setState({ room }, () => {
          this.setTemperatureColors(room)
        })
      })
    }
    if (setPoints) {
      const error = _.get(setPoints, 'errors[0].message', false)
      if (error) {
        this.setState({ active: false, error: 'Device(s) could not be reached, please contact us.' }, () => {
          setTimeout(() => { // Should clear state props from duck
            clearCozyProps()
          }, 1000)
        })
      } else {
        this.setState({ showSaveBtn: true, error: '' }, () => {
          setTimeout(() => {
            clearCozyProps()  // Should clear state props from duck
            this.setState({ showSaveBtn: false })
          }, 1000)
        })
      }
    }
    // Redirects to register page if no cozy has been registered
    if (rooms.length === 0) {
      history.push('/register-cozy')
    }
  }

  componentDidMount() {
    if (!navigator.onLine) { // If offile then pick data from localstorage to work app without error
      const { rooms, room } = this.props
      this.setState({ room, rooms })
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('dayOfWeek') // Remove from local storage when move away from the page
  }
  // To display colors according to the temperature changes
  setTemperatureColors(room) {
    let cssClass = ''
    if (isMobile && room) {
      // For mobile
      if (_.get(room, 'setpoint', this.temperature.MIN) < this.temperature.BLUE) {
        cssClass = 'background-blue-home'
      } else if (_.get(room, 'setpoint', this.temperature.MIN) <= this.temperature.ORANGE) {
        cssClass = 'background-orange-home'
      } else if (_.get(room, 'setpoint', this.temperature.MIN) > this.temperature.RED) {
        cssClass = 'background-red-home'
      }
    } else if (room) {
      if (_.get(room, 'setpoint', this.temperature.MIN) < this.temperature.BLUE) {
        cssClass = 'blue-home'
      } else if (_.get(room, 'setpoint', this.temperature.MIN) <= this.temperature.ORANGE) {
        cssClass = 'orange-home'
      } else if (_.get(room, 'setpoint', this.temperature.MIN) > this.temperature.RED) {
        cssClass = 'red-home'
      }
    }
    const homeTemp = _.get(room, 'setpoint', this.temperature.ORANGE)
    let textColor = ''
    if (room) {
      textColor =
        parseFloat(homeTemp) < this.temperature.BLUE ? 'blue-home' : parseFloat(homeTemp) < this.temperature.ORANGE ? 'orange-home' : 'red-home'
    }
    this.setState({ textColor, cssClass })
  }

  onUpArrowClick() {
    const { room } = this.state
    // Check whether the min and max temperature is not having greater value then the constants on up arrow press
    if (room.setpoint <= this.temperature.MAX) {
      room.setpoint = room.setpoint + 1 > this.temperature.MAX ? this.temperature.MAX : parseFloat(room.setpoint) + 1
      this.setState({ room, active: true }, () => {
        this.setTemperatureColors(room)
      })
    } else {
      this.setPointReleaseUp()
    }
  }

  onDownArrowClick() {
    const { room } = this.state
    // Check whether the min and max temperature is not having greater value then the constants on down arrow press
    if (room.setpoint >= this.temperature.MIN) {
      room.setpoint = room.setpoint - 1 < this.temperature.MIN ? this.temperature.MIN : parseFloat(room.setpoint) - 1
      this.setState({ room, active: true }, () => {
        this.setTemperatureColors(room)
      })
    } else {
      this.setPointReleaseDown()
    }
  }

  setPointUp() {
    this.buttonPressTimer = setInterval(() => {
      this.onUpArrowClick()
    }, 50)
  }

  setPointReleaseUp() {
    // Reset timer on release arrows
    clearTimeout(this.buttonPressTimer)
  }

  setPointDown() {
    this.buttonPressTimer = setInterval(() => {
      this.onDownArrowClick()
    }, 50)
  }

  setPointReleaseDown() {
    // Reset timer on release arrows
    clearTimeout(this.buttonPressTimer)
  }
  // Will be called from child modal component
  showInfo() {
    this.setState({ showInfo: true })
  }
  // Will be called from child modal component
  closeModal() {
    this.setState({ showInfo: false })
  }

  changePoint(e) {
    const { room } = this.state
    room.setpoint = e.target.value
    this.setState({ room, active: true }, () => {
      this.setTemperatureColors(room)
    })
  }

  changeRoom(e) {
    const { rooms } = this.props
    // Set data for a single room filtering using room id and convert fahrenheit to celsius or vice-versa
    const room = _.cloneDeep(rooms.filter(room => room.id === parseInt(e.target.value, 10))[0])
    room.currentTemp = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.currentTemp) : room.currentTemp
    room.home = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.home) : Math.round(room.home)
    room.setpoint = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.setpoint) : Math.round(room.setpoint)
    room.sleep = this.coversion() === 'F' ? this.celsiusToFahrenheit(room.sleep) : Math.round(room.sleep)
    this.setState({ room, roomId: parseInt(e.target.value, 10) }, () => {
      localStorage.setItem('room', this.state.roomId)
      this.props.fetchRooms()
    })
  }
  // API call to set point
  updatePoint() {
    const { setSetPoint } = this.props
    const { room } = this.state
    // Check whether the min and max temperature is not having greater value then the constants on submit
    if (parseFloat(room.setpoint) >= this.temperature.MIN && parseFloat(room.setpoint) <= this.temperature.MAX) {
      this.setState({ active: false, error: '' }, () => {
        let celsiusValue = room.setpoint
        celsiusValue = celsiusValue === this.temperature.MAX ? this.temperature.CELSIUS_ADJUSTMENT_FOR_MAX : celsiusValue

        const data = {
          id: room.id,
          setpoint: this.coversion() === 'F' ? this.fahrenheitToCelsius(room.setpoint) : celsiusValue
        }
        setSetPoint(data)
      })
    } else {
      // show message invalid values
      this.setState({
        error: `Invalid temperatures value. Please try to set between ${this.temperature.MIN}° ${this.coversion()} to ${
          this.temperature.MAX
        } °${this.coversion()}.`
      })
    }
  }

  render() {
    const { room, rooms, roomId, active, showSaveBtn, cssClass, textColor } = this.state
    return (
      <div
        onContextMenu={e => {
          e.preventDefault()
          return false
        }}
      >
        <main id="home-page" className={'mobile-bg ' + cssClass}>
          <div className="fullpage__wrapper">
            <div className="main__section d-flex flex-column">
              <div className="container__section">
                <div className="sectino header__section">
                  <header className="header login-header text-center d-flex align-items-center">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12">
                          <div className="header-inner">
                            <div className="nav-menu-box">
                              <Link to={'/account-info'}>
                                <img alt="" src="/img/menu_icon.svg" />
                              </Link>
                            </div>
                            <div className="logo-box">
                              <img alt="" className="mobile-logo" src="img/white-logo.svg" />
                              <small>Operated by Radiator Labs</small>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </header>
                </div>
                <div className="sectino body__sectino">
                  <div className="fullpage__wrapper--content">
                    <div className="container">
                      <div className="row">
                        <div className="col-md-12 fullpage__wrapper--box justify-content-around text-center d-flex align-items-stretch align-self-stretch flex-column">
                          <div className="temperature-box">
                            <form action="" className="select-cat-box">
                              <select name="timepass" className="custom-select" value={roomId} onChange={e => this.changeRoom(e)}>
                                {rooms &&
                                  rooms.map((room, i) => {
                                    return (
                                      <option key={i} value={room.id}>
                                        {_.get(room, 'nickname') || _.get(room, 'name')}
                                      </option>
                                    )
                                  })}
                              </select>
                            </form>
                            {
                              _.get(room, 'currentTemp') ?
                              <span>
                                {Math.round(_.get(room, 'currentTemp'))}
                                <small>°{this.coversion()}</small>
                              </span>
                              :
                              <span className="device-title">
                                Device Offline
                              </span>
                            }
                            <h5> Current Temperature </h5>
                          </div>
                          <div className="temperature-box">
                            <h4 className="temperature-title">
                              Set it to
                              <a className="info" onClick={this.showInfo}>
                                <img alt="" src="/img/info_white_icon.svg" />
                              </a>
                            </h4>
                            <div className="fahrenheit-two">
                              <div className="temperature-inner-box">
                                <button
                                  className="arrow-img-down"
                                  onTouchStart={this.setPointDown}
                                  onTouchEnd={this.setPointReleaseDown}
                                  onMouseDown={this.setPointDown}
                                  onMouseUp={this.setPointReleaseDown}
                                />
                                <span className={`${textColor} temperature-digree`}>
                                  <NumberFormat format="##" value={_.get(room, 'setpoint', 78)} onChange={this.changePoint} />
                                  <small className="degree-sign">°{this.coversion()}</small>
                                </span>
                                <button
                                  className="arrow-img-up"
                                  onTouchStart={this.setPointUp}
                                  onTouchEnd={this.setPointReleaseUp}
                                  onMouseDown={this.setPointUp}
                                  onMouseUp={this.setPointReleaseUp}
                                />
                              </div>
                              <div>
                                <p className="device__sms">{this.state.error}</p>
                                {showSaveBtn ? (
                                  <button className="btn btn-lg btn-block update-btn update-btn-active">Saved!</button>
                                ) : (
                                  <button className="btn btn-lg btn-block update-btn" disabled={!active} onClick={() => this.updatePoint()}>
                                    Update
                                  </button>
                                )}
                                <a rel="noopener noreferrer" href="https://radiatorlabs.zendesk.com/hc/en-us/requests/new" target="_blank">
                                  <p>Not Cozy? Contact Us</p>
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <CommonModal key="note" modalType="note" open={this.state.showInfo} {...this.props} closeModal={this.closeModal} />
                {/*<div className="sectino footer__section">
                  <footer>
                    <div className="row">
                      <div className="col-md-12">
                        <Link to={`/temperature-schedule?roomId=${_.get(room, 'id', 1)}`}>
                          <img alt="" src="/img/calendar_icon.svg" />
                          Edit Room Schedule
                        </Link>
                      </div>
                    </div>
                  </footer>
                </div>*/}
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  }
}
export default Home



// WEBPACK FOOTER //
// ./src/views/Home/component.js